<template>
    <div :class="css.navigations">
        <div :class="css.header">
            <div class="container">
                <div :class="css.tag" class="color-1" v-if="data?.tag">{{ data.tag }}</div>
                <div :class="css.name" class="font-variable font-bold">{{ name }}</div>
                <default-search
                    :class="css.search"
                    v-model="gene"
                    mode="select"
                    type="gene"
                    :query="{ tax_names: selector }"
                    :placeholder="$t('ChangeGene')"
                    @search="methods.change" />
            </div>
        </div>

        <div :class="css.body">
            <div class="container flex items-center justify-between">
                <div>
                    <!-- * 基因序列信息 -->
                    <template v-for="r in option">
                        <div :class="[css.navigation, ($route.query.mode || '') == r.value && css.active]" @click="$emit('update', r.value)">
                            {{ r.name }}
                        </div>
                    </template>
                </div>
                <Favorites size="small" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 公共组件
import { DefaultSearch, Favorites } from "@/components/controls";
//* 组件属性
import { ModulePropsOption, ModuleEmits } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组件属性注册
const emits = defineEmits(ModuleEmits);
const define = defineProps(ModulePropsOption);

//* 组合函数
const { refs, methods, computeds } = useComposable(define);
const { name, selector } = computeds;
const { gene } = refs;
</script>
